import React from 'react'
import { Button, Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export default function SchedulesEmpty() {
  return (
    <Card style={{ border: '0px' }}>
      <Card.Body>
        <h5 className='font-weight-bold'>
          No Mass Schedules To Display.
        </h5>
        <div className='my-4'>
          When you have Mass Schedules they will appear here. Start by creating a Mass Schedule below.
        </div>
        <Button as={Link} to='/vaccine/schedule/create' variant='outline-primary' className="px-5">
          Create Mass Schedule
        </Button>
      </Card.Body>
    </Card>
  )
}
